import React, { useMemo, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Segmented, SelectFilter, StatusDot, CountLabel, NoResults } from "../components/Bits";
import {
  TICKETS, SEVERITY_META, TICKET_STATUS_META,
  SEVERITY_FILTERS, TICKET_STATUS_FILTERS,
} from "../data/mockData";

/** Support queue. The leading cell carries a 3px severity rail, as in the design. */
const TicketsQueue = () => {
  const navigate = useNavigate();
  const { search } = useOutletContext();
  const [severity, setSeverity] = useState("all");
  const [status, setStatus] = useState("all");

  const filtered = useMemo(
    () =>
      TICKETS.filter((t) => {
        if (severity !== "all" && t.severity !== severity) return false;
        if (status !== "all" && t.status !== status) return false;
        if (search && !(t.subject.toLowerCase().includes(search) || t.requester.toLowerCase().includes(search))) return false;
        return true;
      }),
    [severity, status, search]
  );

  return (
    <>
      <div className="admin-toolbar">
        <Segmented name="severityFilter" options={SEVERITY_FILTERS} value={severity} onChange={setSeverity} />
        <SelectFilter value={status} onChange={setStatus} options={TICKET_STATUS_FILTERS} minWidth={150} />
        <div className="admin-spacer" />
        <CountLabel shown={filtered.length} total={TICKETS.length} noun="tickets" />
      </div>

      <div className="card admin-table-card">
        <table className="table">
          <thead>
            <tr>
              <th className="admin-cell-lead">Ticket</th>
              <th>Requester</th>
              <th>Category</th>
              <th>Severity</th>
              <th>Status</th>
              <th>Opened</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && <NoResults colSpan={7} />}
            {filtered.map((t) => {
              const sev = SEVERITY_META[t.severity];
              const st = TICKET_STATUS_META[t.status];
              return (
                <tr key={t.id} className="admin-row-link" onClick={() => navigate(`/admin/tickets/${t.id}`)}>
                  <td className="admin-severity-cell" style={{ borderLeftColor: sev.color }}>
                    <div className="admin-cell-strong">{t.subject}</div>
                    <div className="admin-cell-sub">{t.id}</div>
                  </td>
                  <td>{t.requester}</td>
                  <td><span className="tag tag-neutral">{t.category}</span></td>
                  <td><StatusDot color={sev.color} label={sev.label} /></td>
                  <td><span className={`tag ${st.tagClass}`}>{st.label}</span></td>
                  <td className="admin-muted-cell">{t.created}</td>
                  <td className="admin-chevron">›</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default TicketsQueue;
